<script>
import { mapActions, mapGetters } from 'vuex'
import http from '../http'
import CardActivations from '../components/CardActivations.vue'
export default {
    components: {
        CardActivations
    },
    data() {
        return {
            agencies: [],
            region: null,
        }
    },
	computed: {
      
		...mapGetters({
			wallet: 'auth/wallet',
			user: 'auth/user',
		})
	},
	methods: {
		goToHistory(user_id) {
			this.$router.push({name: 'HistoryActivations', params: {id: user_id}})
		},
        
        async fetchAgencies () {
            let id = this.$route.params.id
            try {
                let data = await http.agencies.byRegion(id)
                this.$set(this, 'agencies', data.agencies)
                this.$set(this, 'region', data.region)
            } catch (error) {
                
            }
        },
        gotTo(data) {
			this.$router.push(data)
		},

		...mapActions({
			fetchUser: 'auth/fetchUser',
            fetchTerritories: 'stats/fetchTerritories',

		})
	},
	mounted() {
		this.fetchUser()
        this.fetchAgencies()
		// this.fetchTerritoryReferals()
	}
}
</script>
<template>
	<div class="ranking" v-if="user">
		<div class="vault__header">
			<div class="vault__header-content">
				<div class="vault__header-wrapper flex-wrap text-center w-100 ">
					<h5 class="m-0 w-100 text-center mb-2">Agencias</h5>
					<h6 class="fw-bold text-center w-100" v-if="region">{{region.name}}</h6>

				</div>
			</div>
		</div>

        <div class="mt-3 px-3">
            <div v-if="agencies.length">
                <CardActivations 
                    v-for="(agency, index) in agencies" 
                    :key="`t_${agency.id}_${index}`"
                    :title="agency.name"
                    :activators="agency.users"
                    :total="agency.activations"
                    :now="agency.activations_now"
                    :weekly="agency.activations_weekly"
                    :weekly_goal="agency.weekly_goal" 
                    :route="'AgencyRanking'"
                    :id="agency.id"
                />
            </div>
            <div class="d-flex" v-else>
                <div class="mx-auto">
                    <div class="lds-ripple"><div></div><div></div></div>
                    <p class="text-center text-white">Cargando...</p>
                </div>
            </div>
        </div>
		
	</div>
</template>

<style lang="scss" scoped>
.start__top{
	height: 35vh;
	margin-bottom: 0;
	.start__robot--front{
		bottom: -1rem;
	}
}
</style>